import { render, staticRenderFns } from "./quickServiceWidget.vue?vue&type=template&id=572cd882&scoped=true"
import script from "./quickServiceWidget.vue?vue&type=script&lang=js"
export * from "./quickServiceWidget.vue?vue&type=script&lang=js"
import style0 from "./quickServiceWidget.vue?vue&type=style&index=0&id=572cd882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572cd882",
  null
  
)

export default component.exports